export const testInfo = {
    "question_number": "ເບີຄຳຖາມ",
    "question_number_learning": "ຈຳນວນເນື້ອຫາທີ່ຕ້ອງເຮັດ",
    "number_of": "ການທົດສອບ",
    "welcome_final_test": "ຍິນດີຕ້ອນຮັບສູ່ການທົດສອບສຸດທ້າຍ",
    "max_try_time": "ການທົດສອບສູງສຸດ",
    "number_try_time": "ຈຳນວນການທົດສອບ",
    "unlimited": "ບໍ່ຈຳກັດການທົດສອບ",
    "SUBMITTING": "ກຳລັງສົ່ງ",
};

